module.exports = " <div class=weui_loading_toast v-show=show> <div class=weui_mask_transparent></div> <div class=weui_toast :style=\"{position: position}\"> <div class=weui_loading> <div class=weui_loading_leaf v-for=\"i in 12\" :class=\"['weui_loading_leaf_' + i]\"></div> </div> <p class=weui_toast_content>{{text}}<slot></slot></p> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/loading/index.vue
// module id = 229
// module chunks = 2